const splitUrlIntoOriginAndPath = (urlString: string): { origin: string; path: string } => {
  const url = new URL(urlString);

  return {
    origin: url.origin,
    path: url.pathname.replace(/^\/|\/$/g, ''),
  };
};

export default splitUrlIntoOriginAndPath;
